import { defineStore } from 'pinia';
import type { FavoriteMenu } from "@/types/property-manager/prop-000";

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    notification: 0 as number,
  }),
  actions: {
    setter(notification: number) {
      this.notification = notification;
    },
  },
});